<div class="ms-2 me-2">
<div style="border-bottom: 1px solid lightgrey;margin: 10px;">
  <div *ngIf="data" class="ms-2 me-2 col-md-8 col-sm-10 col-xs-11 border">
    <form [formGroup]="meetingdetaileditform" (ngSubmit)="onSubmit()">
      <div class="ms-2 me-2">
        <div>
          <label for="meetingDate">Datum</label>
          <input [required]=true id="meetingDate" type="text" class="form-control form-control-sm" style="width:100px;"
          mask="0000-00-00" formControlName="meetingDate">
        </div>
        <div>
          <label for="issue">Rubrik</label>
          <input id="issue" type="text" class="form-control form-control-sm" maxlength="30" formControlName="issue">
        </div>
        <div>
          <label for="comment">Kommentar</label>
          <input id="comment" type="text" class="form-control form-control-sm" formControlName="comment">
        </div>
        </div>
      <br>
     
        <mat-radio-group class="ms-2" aria-label="Mötestyp" formControlName="meetingTypeId">
  <mat-radio-button class="me-3" [value]="1">Ordinarie</mat-radio-button>
  <mat-radio-button class="me-3" [value]="2">Sommar</mat-radio-button>
  <mat-radio-button [value]="3">Övrigt</mat-radio-button>
</mat-radio-group>
        
    </form>
    <br>
    <div class="d-flex justify-content-start ms-2 flex-wrap gap-2">
      
    <button class="btn border"
      *ngIf="can_edit_attendance && role?.userPermissionLevel !== 'ME' && (!edit && !viewmode && !usualmember)"
      (click)="edit=true;disableForm(false);">Ändra</button>
    <button class="btn border"
      *ngIf="can_edit_attendance && role?.userPermissionLevel !== 'ME' && (edit && !viewmode && !usualmember)"
      (click)="save()">Spara</button>
    <button class="btn border" *ngIf="can_edit_attendance && role?.userPermissionLevel !== 'ME' && edit"
      (click)="cancel()">Avbryt</button>
    <button *ngIf="can_edit_attendance && role?.userPermissionLevel !== 'ME'" class="btn border"
      (click)="confirmDeleteDialog()">Radera möte</button>
    <button class="btn border" *ngIf="role?.userPermissionLevel !== 'ME' && !edit" (click)="cancelMeetingDetails()">Tillbaka</button>
      
      </div>
    <br>
  </div>
  <br>
  <div class="row">
    <div class="col-md-1">Totalt: {{attendants?.length + guestattendants?.length}}</div>
    <div class="col-md-1">Ordinarie: {{attendants?.length}}</div>
    <div class="col-md-1">Gäster: {{guestattendants?.length}}</div>
  </div>
</div>
<div *ngIf="!usualmember && !edit">
  <div class="d-flex justify-content-start">
    <div>
      <div class="p-2 fw-bold">Närvarolista</div>
      <div class="d-flex justify-content-start ms-2 gap-1 flex-wrap">
        <button *ngIf="can_edit_attendance" class="btn border" (click)="deleteAttendants();deletelist = []"
          [disabled]="deletelist.length === 0">Ta bort valda</button>
        <button *ngIf="can_edit_attendance" class="btn border" (click)="addAttendant('ordinary')"
          [disabled]="add || deletelist.length !== 0">Lägg till</button>
        <button *ngIf="can_edit_attendance" class="btn border" (click)="addAttendant('guest')"
          [disabled]="addguest || deletelist.length !== 0">Lägg till gäst</button>
      </div>

   
      <br>
     <div class="d-flex justify-content-start flex-wrap">
      <div>
      <mat-expansion-panel>
        <mat-expansion-panel-header [expandedHeight]="'28px'" [collapsedHeight]="'28px'">

          <mat-panel-title>
            Egna medlemmar [{{attendants?.length}}]
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!--div class="pull-right"> 
    <mat-checkbox *ngIf="can_edit_attendance && attendants.length > 0" #markAll
          (change)="markAllAttendants(markAll);">Välj alla</mat-checkbox>
    </div-->
        <mat-panel-description>

          <table matSort (matSortChange)="sortData($event)" class="table table-bordered border"
            matSortDisableClear=true>
            <thead role="rowgroup">
              <tr>
                <th>Nr</th>
                <th mat-sort-header="id">Id</th>
                <th mat-sort-header="givenName">Förnamn</th>
                <th mat-sort-header="familyName">Efternamn</th>
                <th>Inst.</th>
                <th>Prim.inst.</th>
                <th *ngIf="can_edit_attendance">
                  
                  <mat-checkbox *ngIf="can_edit_attendance && attendants.length > 0" #markAll
          (change)="markAllAttendants(markAll);">Välj alla</mat-checkbox>
                </th>
              </tr>
            </thead>

            <tr *ngFor="let a of attendants; let i = index">
              <td>
                <b>{{i + 1}}</b>
              </td>
              <td>
                <a [routerLink]="['/memberform/id/', a.memberId]">{{a.memberId}}</a>
              </td>
              <td>{{a.givenName}}</td>
              <td>{{a.familyName}}</td>
              <td><a [routerLink]="['/institutions/id/', a.institutionId]"
                  title="{{a.institutionName}}">{{a.institutionShortName}}</a></td>
              <td><a [routerLink]="['/institutions/id/', a.primaryInstitution.id]"
                  title="{{a.primaryInstitution.name}}">{{a.primaryInstitution.shortName}}</a></td>
              <td *ngIf="can_edit_attendance" style="text-align:center;">
                <mat-checkbox #inputEl (change)="addToDeleteList(a.memberId, a.attendanceId, inputEl);"
                  [checked]=a.checked></mat-checkbox>
              </td>
            </tr>
          </table>
        </mat-panel-description>
      </mat-expansion-panel>

<div>
   
      <mat-expansion-panel>
        <mat-expansion-panel-header [expandedHeight]="'28px'" [collapsedHeight]="'28px'">
          <mat-panel-title>
            Gäster [{{guestattendants?.length}}]
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-panel-description>
          <table matSort (matSortChange)="sortData($event)" class="table table-bordered border"
            matSortDisableClear=true>
            <thead role="rowgroup">
              <tr>
                <th>Nr</th>
                <th mat-sort-header="Id">Id</th>
                <th mat-sort-header="givenName">Förnamn</th>
                <th mat-sort-header="familyName">Efternamn</th>
                <th>Inst.</th>
                <th mat-sort-header="primaryInstitution">Prim.inst.</th>
                <th *ngIf="can_edit_attendance"></th>
              </tr>
            </thead>
          
            <tr *ngFor="let a of guestattendants; let i = index">
              <td>
                <b>{{i + 1}}</b>
              </td>
              <td style="text-align: right;">
                <a [routerLink]="['/memberform/id/', a.memberId]">{{a.memberId}}</a>
              </td>
              <td>{{a.givenName}}</td>
              <td>{{a.familyName}}</td>
              <td><a [routerLink]="['/institutions/id/', a.institutionId]"
                  title="{{a.institutionName}}">{{a.institutionShortName}}</a></td>
              <td><a [routerLink]="['/institutions/id/', a.primaryInstitution.id]"
                  title="{{a.primaryInstitution.name}}">{{a.primaryInstitution.shortName}}</a></td>
              <td *ngIf="can_edit_attendance" style="text-align:center;">
                <mat-checkbox #inputEl (change)="addToDeleteList(a.memberId, a.attendanceId, inputEl);"></mat-checkbox>
              </td>
            </tr>
          </table>
        </mat-panel-description>
      </mat-expansion-panel>
    </div>
</div>
    <br>
 
    <div *ngIf="add || (addguest && selectedinstitution)" class="ms-3 border">
      <div style="padding: 5px;vertical-align: middle;padding-left:5px;">
        <b>Välj deltagare</b>
        <button *ngIf="add && !selectedinstitution" (click)="saveAttendants()"
          [disabled]="addattendancelist.length === 0" style="margin-left:20px;" class="btn border">Spara</button>
        <button *ngIf="!selectedinstitution" class="btn border" (click)="cancelAddingAttendants()"
          style="margin-left:10px;" [disabled]="(!add)">Avbryt lägg till</button>
        <div *ngIf="selectedinstitution">
          <b style="font-size:14px;">{{selectedinstitutionname}}</b>
          <div>
          <button class="btn border" style="margin-left:20px;" title="Byt institution"
            (click)="selectedinstitution=null;clear();addattendancelist=[]">Byt institution</button>
          <button class="btn border" (click)="saveAttendants()" [disabled]="addattendancelist.length < 1"
            style="margin-left:20px;" class="btn">Spara</button>
          <button class="btn border" (click)="cancelAddingAttendants()" style="margin-left:10px;"
            [disabled]="(!addguest)">Avbryt</button>
            </div>
        </div>
      </div>
      <table matSort (matSortChange)="sortAddData($event)" class="table table-bordered border"
        matSortDisableClear=true>
        <thead role="rowgroup">
          <tr>
            <th mat-sort-header="id">Id</th>
            <th mat-sort-header="givenName">Förnamn</th>
            <th mat-sort-header="familyName">Efternamn</th>
            <th mat-sort-header="priminst">Prim.Inst.</th>
            <th>Välj</th>
          </tr>
        </thead>
        <tr *ngFor="let a of attendantstoadd; let i = index">
          <td style="text-align: right;">
            <a [routerLink]="['/memberform/id/', a.id]" title="Titta på medlemsdetaljer">{{a.id}}</a>
          </td>
          <td>{{a.givenName}}</td>
          <td>{{a.familyName}}</td>
          <td><a [routerLink]="['/institutions']" [queryParams]="{id: a.institutionId}" queryParamsHandling="merge"
              title="{{a.institutionName}}}">{{a.institutionShortName}}</a></td>
          <br>
          <td style="text-align: center;">
            <mat-checkbox #inputEl (change)="addAttendantToList(a.id, inputEl);"></mat-checkbox>
          </td>
        </tr>
      </table>
    </div>
    
    <div *ngIf="addguest && !selectedinstitution" class="ms-3" style="min-width:400px;">
      <button *ngIf="!selectedinstitution" class="btn border" (click)="cancelAddingAttendants()"
        [disabled]="(!addguest)">Avbryt lägg till</button>
      <div class="form-group">
        <label for="institutionId">Institution</label>
       
        <div>
          <p-autoComplete 
            [(ngModel)]="value"
            [suggestions]="filteredInstitutions"
            (completeMethod)="search($event)"
            field="name"
            [showClear]="true"
            (onSelect)="onInstitutionSelected($event)"
            style="height: 30px; font-size: 16px;"
            [dropdown]="true">

          <ng-template let-option pTemplate="option">
            {{ option.name }} <b> [{{ option.shortName }}]</b>
          </ng-template>
    </p-autoComplete>
       
        </div>

      </div>
    </div>
     </div>
  </div>
</div>
  </div>